import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './Nav.module.scss';
import Image from '../../Image';
import logo from '../../../assets/logo.jpg';
import menu from '../../../assets/nav/menu.png';
import { routes } from '../../../routes';
import cart from '../../../assets/nav/cart.png';

export default function RailsMobileNav() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const getCurrentDomain = () => {
    const hostname = window.location.hostname;
    if (hostname.includes('shoob.cloud')) {
      return 'https://www.shoob.cloud';
    } else {
      return 'https://www.shoobphoto.com';
    }
  }

  useEffect(() => {
    if (!isOpen) return;

    setIsLoginOpen(false);
  }, [isOpen]);

  useEffect(() => {
    if (!isLoginOpen) return;

    setIsOpen(false);
  }, [isLoginOpen]);

  const isSignedIn = document.querySelector('#current-user');

  return (
    <nav
      className={cn({
        [styles.navContainer]: true,
        noPrint: true,
        'rails-nav': true,
      })}
      style={{ display: 'flex', justifyContent: 'space-between' }}
    >
      <div className={cn(styles.cartLink, styles.dropdown)} style={{ marginLeft: '1em' }}>
        <button
          className={styles.button}
          style={{ padding: '.5em' }}
          onClick={() => setIsLoginOpen(!isLoginOpen)}
          type="button"
        >
          <Image alt="Menu" src={menu} />
        </button>
        <ul
          className={cn({
            [styles.dropdownMenu]: true,
            [styles.hidden]: !isLoginOpen,
          })}
        >
          {/* PURCHASE PICTURES */}
          <li>
            <a href={`/c${routes.studentIdEntry()}`}>
              Order School Pictures
            </a>
          </li>
          <li>
            <a href={`/c${routes.studentIdEntry({ order: 'senior' })}`}>
              Order Senior Portraits
            </a>
          </li>
          <li>
            <a href={`/c${routes.studentIdEntry({ order: 'yearbook_order' })}`}>
              Order Yearbooks
            </a>
          </li>
          <li>
            <a href={`/c${routes.studentIdEntry({ order: 'panorama' })}`}>
              Order Groups and Panorama
            </a>
          </li>

          {/* OTHER LINKS */}
          <li>
            <a href={`/c${routes.scheduleAppointment()}`}>
              Make Appointment
            </a>
          </li>
          <li>
            <a href={`/c${routes.downloadImageForm()}`}>
              Download Digital Files
            </a>
          </li>
          <li>
            <a href={getCurrentDomain() === 'https://www.shoob.cloud'  ? 'https://www.shoobphotosouth.com/contact1' : '/contacts/new'}>
              Contact Us
            </a>
          </li>
          <li>
            <a href="/school_resources">
              Resources for Schools
            </a>
          </li>
          <li>
            <a href={`/c${routes.registration()}`}>
              Register
            </a>
          </li>

          {/* CART */}

          <li>
            <a href={`/c${routes.cart()}`}>
              My Cart
            </a>
          </li>

          {/* USER LOGIN */}
          <li>
            <a href={isSignedIn ? '/pages/home' : '/users/sign_in'}>
              {isSignedIn ? 'Home Page' : 'School Login'}
            </a>
          </li>
          {!isSignedIn && (
            <li>
              <a href="/users/sign_in">
                Shoob Employee Login
              </a>
            </li>
          )}
        </ul>
      </div>
      <a href="/" style={{ paddingRight: '1em' }}>
        <Image src={logo} classes={styles.logo} />
      </a>
    </nav>
  );
}
